import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import store from './store';
import { App } from './App';
import './styles/index.scss';

// Debug function to access env variables from browser console
(window as any).cHJpbnR2YXJz = (envVarName: string): string | null => {
  const value = (process.env as Record<string, string | undefined>)[envVarName];
  return value ?? null;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
);
